module.exports = __webpack_public_path__ + "static/media/downloadGoogleSpanish.c4bb0f5c.png";